import { useState } from 'react';
import { Button, Dropdown, Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { clearRecentUsers, getRecentUsers } from '../../helpers/recentUsers';

const { Text } = Typography;

export default function RecentUsersMenu() {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);

  const onOpenChange = (nextOpen) => {
    if (nextOpen) setUsers(getRecentUsers());
    setOpen(nextOpen);
  };

  const openUser = (userId) => {
    setOpen(false);
    history.push(`/user/${userId}`);
  };

  const clearList = () => {
    clearRecentUsers();
    setUsers([]);
  };

  const menu = (
    <div style={{ width: 320, maxWidth: '90vw', padding: 8, background: '#fff', borderRadius: 6, boxShadow: '0 3px 12px rgba(0, 0, 0, 0.15)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 8px 4px' }}>
        <Text strong>Recently viewed</Text>
        {users.length > 0 && <Button type="link" size="small" onClick={clearList}>Clear</Button>}
      </div>
      {users.length === 0 && <div style={{ padding: 8 }}><Text type="secondary">No recently viewed users yet</Text></div>}
      {users.map((user) => (
        <Button
          key={user.userId}
          block
          type="text"
          onClick={() => openUser(user.userId)}
          style={{ display: 'block', height: 'auto', padding: '6px 8px', textAlign: 'left', whiteSpace: 'normal' }}>
          <Text strong style={{ display: 'block' }} ellipsis>{user.name || user.userId}</Text>
          <Text type="secondary" style={{ display: 'block', fontSize: 12 }} ellipsis>
            {user.email ? `${user.email}, ` : ''}{moment(user.viewedAt).fromNow()}
          </Text>
        </Button>
      ))}
    </div>
  );

  return (
    <Dropdown open={open} onOpenChange={onOpenChange} trigger={['click']} placement="bottomRight" dropdownRender={() => menu}>
      <Button type="link" icon={<ClockCircleOutlined />} style={{ color: '#fff' }}>Recent</Button>
    </Dropdown>
  );
}
